import {$http} from '@/utils/https'
import axios from 'axios'

import {
    CHANGE_CATEGORY_LOADING,
    CHANGE_ONE_CATEGORY_LOADING,
    CHANGE_PRODUCT_LOADING,
    FILTERED_PRODUCTS_LOADING,
    PRODUCT_FILTERS_LOADING,
    SET_CATEGORY,
    SET_CURRENT_CATEGORY,
    SET_FILTERED_PRODUCTS,
    SET_ONE_CATEGORY,
    SET_PRODUCT,
    SET_PRODUCT_FILTERS,
    SAVE_ATTRIBUTES_VALUE,
    SKIP_PAGINATION,
    SET_SEARCH_LIST,
    SEARCH_LIST_LOADING,
    CLEAR_SEARCH_LIST,
    SHOW_MOBILE_FILTERS,
    SHOW_CONSULTATION_POPUP,
} from '../mutation-types';

import {
    CATALOG_SEARCH,
    GET_CATEGORY,
    GET_CURRENT_CATEGORY,
    GET_FILTERED_PRODUCTS,
    GET_ONE_CATEGORY,
    GET_PRODUCT,
    GET_PRODUCT_FILTERS, PRODUCT_SEARCH
} from '../action-types';

const ALL_PRODUCTS_PER_PAGE = 1000;
let oneCategoryRequestSeq = 0
let productFiltersRequestSeq = 0
let filteredProductsRequestSeq = 0

function normalizeProductFilters(raw) {
    if (!raw || typeof raw !== 'object') {
        return { filters: [], prices: { min: 0, max: 999999 } }
    }
    const out = { ...raw }
    if (!Array.isArray(out.filters)) {
        out.filters = []
    }
    if (!out.prices || typeof out.prices.min === 'undefined' || typeof out.prices.max === 'undefined') {
        out.prices = { min: 0, max: 999999 }
    }
    return out
}

const state = {
    searchList: [],
    categoryList: [],
    oneCategoryList: [],
    categoriesIsLoading: false,
    oneCategoriesIsLoading: false,
    currentProduct: '',
    currentProductLoading: false,
    currentCategory: '',
    productFilters: '',
    productFiltersLoading: false,
    filteredProducts: '',
    filteredProductsLoading: false,
    attributesValue: '',
    pagination: {
        per_page: 15,
        page: 1
    },
    searchListLoading: '',
    showMobileFilters: false,
    showConsultationPopup: false
};

const getters = {
    showConsultationPopup: state => state.showConsultationPopup,
    showMobileFilters: state => state.showMobileFilters,
    searchListLoading: state => state.searchListLoading,
    searchList: state => state.searchList,
    pagination: state => state.pagination,
    attributesValue: state => state.attributesValue,
    filteredProductsLoading: state => state.filteredProductsLoading,
    filteredProducts: state => state.filteredProducts,
    productFiltersLoading: state => state.productFiltersLoading,
    productFilters: state => state.productFilters,
    categoryList: state => state.categoryList,
    categoriesIsLoading: state => state.categoriesIsLoading,
    oneCategoryList: state => state.oneCategoryList,
    oneCategoriesIsLoading: state => state.oneCategoriesIsLoading,
    currentProduct: state => state.currentProduct,
    currentProductLoading: state => state.currentProductLoading,
    currentCategory: state => state.currentCategory
};

const actions = {
    [GET_CURRENT_CATEGORY]: async ({commit}, slug) => {
        // commit(CHANGE_CATEGORY_LOADING, true);
        try {
            const response = await $http.get(`v1/categories/${slug}`);
            commit(SET_CURRENT_CATEGORY, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(CHANGE_CATEGORY_LOADING, false);
        }
    },
    [GET_CATEGORY]: async ({commit}) => {
        commit(CHANGE_CATEGORY_LOADING, true);
        try {
            const response = await $http.get(`v1/categories`);
            commit(SET_CATEGORY, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_CATEGORY_LOADING, false);
        }
    },
    [GET_ONE_CATEGORY]: async ({commit}, slug) => {
        const requestId = ++oneCategoryRequestSeq
        commit(CHANGE_ONE_CATEGORY_LOADING, true);

        try {
            const response = await $http.get(`v1/catalog/${slug}/products?per_page=${ALL_PRODUCTS_PER_PAGE}&page=1`);
            if (requestId !== oneCategoryRequestSeq) {
                return
            }
            commit(SET_ONE_CATEGORY, response.data);
        } catch (e) {
            if (requestId !== oneCategoryRequestSeq) {
                return
            }
            throw e;
        } finally {
            if (requestId === oneCategoryRequestSeq) {
                commit(CHANGE_ONE_CATEGORY_LOADING, false);
            }
        }
    },
    [GET_PRODUCT]: async ({commit}, slug) => {
        commit(CHANGE_PRODUCT_LOADING, true);

        try {
            const response = await $http.get(`v1/catalog/product/${slug}`);
            commit(SET_PRODUCT, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_PRODUCT_LOADING, false);
        }
    },
    [GET_PRODUCT_FILTERS]: async ({commit}, payload) => {
        const requestId = ++productFiltersRequestSeq
        const slug = typeof payload === 'string' ? payload : payload.slug;
        const params = typeof payload === 'object' && payload.params ? payload.params : {};
        commit(PRODUCT_FILTERS_LOADING, true);
        try {
            const response = await $http.get(`v1/catalog/${slug}/filters`, {params});
            if (requestId !== productFiltersRequestSeq) {
                return
            }
            const normalized = normalizeProductFilters(response.data.data)
            commit(SET_PRODUCT_FILTERS, normalized);
        } catch (e) {
            if (requestId !== productFiltersRequestSeq) {
                return
            }
            commit(SET_PRODUCT_FILTERS, normalizeProductFilters(null));
            throw e;
        } finally {
            if (requestId === productFiltersRequestSeq) {
                commit(PRODUCT_FILTERS_LOADING, false);
            }
        }
    },
    [GET_FILTERED_PRODUCTS]: async ({commit}, payload) => {
        const requestId = ++filteredProductsRequestSeq
        commit(CHANGE_ONE_CATEGORY_LOADING, true);
        try {
            const params = {
                per_page: payload.limit,
                page: payload.page,
                ...(payload.facets || {})
            }
            if (payload.price_min != null && payload.price_min !== '') {
                params.price_min = payload.price_min
            }
            if (payload.price_max != null && payload.price_max !== '') {
                params.price_max = payload.price_max
            }
            const response = await $http.get(`v1/catalog/${payload.slug}/products`, {params});
            if (requestId !== filteredProductsRequestSeq) {
                return
            }
            commit(SET_FILTERED_PRODUCTS, response.data);
            commit(SAVE_ATTRIBUTES_VALUE, payload)
        } catch (e) {
            if (requestId !== filteredProductsRequestSeq) {
                return
            }
            throw e;
        } finally {
            if (requestId === filteredProductsRequestSeq) {
                commit(CHANGE_ONE_CATEGORY_LOADING, false);
            }
        }
    },
    [CATALOG_SEARCH]: async ({commit}, payload) => {
        commit(SEARCH_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/search?text=${payload.text}`);
            commit(SET_SEARCH_LIST, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SEARCH_LIST_LOADING, false);
        }
    },
    [PRODUCT_SEARCH]: async ({commit}, payload) => {
        commit(CHANGE_ONE_CATEGORY_LOADING, true);
        try {
            const response = await $http.get(`v1/catalog/${payload.slug}/products?search=${payload.search}`);
            commit(SET_FILTERED_PRODUCTS, response.data);
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_ONE_CATEGORY_LOADING, false);
        }
    },
};

const mutations = {
    [SEARCH_LIST_LOADING](state, status) {
        state.searchListLoading = status
    },
    [SET_SEARCH_LIST](state, data) {
        state.searchList = data
    },
    [FILTERED_PRODUCTS_LOADING](state, status) {
        state.filteredProductsLoading = status
    },
    [SET_FILTERED_PRODUCTS](state, data) {
        state.oneCategoryList = data
    },
    [PRODUCT_FILTERS_LOADING](state, status) {
        state.productFiltersLoading = status
    },
    [SET_PRODUCT_FILTERS](state, data) {
        state.productFilters = data
    },
    [SET_CATEGORY](state, data) {
        state.categoryList = data;
    },
    [SET_ONE_CATEGORY](state, data) {
        state.oneCategoryList = data;
    },
    [CHANGE_CATEGORY_LOADING](state, status) {
        state.categoriesIsLoading = status;
    },
    [CHANGE_ONE_CATEGORY_LOADING](state, status) {
        state.oneCategoriesIsLoading = status;
    },
    [SAVE_ATTRIBUTES_VALUE](state, data) {
        state.attributesValue = data;
        if (data && data.limit != null) {
            state.pagination.per_page = Number(data.limit) || state.pagination.per_page;
        }
        if (data && data.page != null) {
            state.pagination.page = Number(data.page) || state.pagination.page;
        }
    },
    [SET_PRODUCT](state, data) {
        state.currentProduct = data
        let arr = []
    },
    [CHANGE_PRODUCT_LOADING](state, status) {
        state.currentProductLoading = status;
    },
    [SET_CURRENT_CATEGORY](state, data) {
        state.currentCategory = data
    },
    [SKIP_PAGINATION](state, value) {
        state.pagination.page = value
    },
    [CLEAR_SEARCH_LIST](state) {
        state.searchList = []
    },
    [SHOW_MOBILE_FILTERS](state, status) {
        state.showMobileFilters = status
    },
    [SHOW_CONSULTATION_POPUP](state, status) {
        state.showConsultationPopup = status
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
